<div class="notification-item flex align-flex-start gap-3 py-3 cursor-pointer" (click)="onNotificationClicked()">
  <span
    class="notification-item__icon box noshrink flex align-center justify-center p-2 radius-2"
    [ngClass]="notification.isRead ? 'bg-primary-lighter text-600' : 'bg-secondry-light text-secondry'"
  >
    <app-icon [name]="icon"></app-icon>
  </span>

  <div class="notification-item__details box grow-fixed flex column">
    <span class="notification-item__title weight-normal">{{ notification.title }}</span>
    <span class="notification-item__body weight-normal text-primary-200">{{ notification.body }}</span>
    <span *ngIf="notification.createdAt" class="notification-item__time weight-medium text-primary-200">{{ timeLabel }}</span>
  </div>

  <span *ngIf="!notification.isRead" class="notification-item__dot box noshrink bg-secondry radius-50"></span>
</div>
